<template lang="pug">
.fam-picker-instruction
  .copy(v-if="!verifyComplete") 完成人脸核验后，可现场扫脸开启互动体验；<br/>若跳过人脸核验，可现场扫码开启互动体验。
  //- .copy(v-else) 可添加1个成人, 2个儿童一起体验展项
  //- .copy(v-else) 可添加1个儿童一起体验展项
  
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'FamPickerInstruction',
  props: {
    verifyComplete: {},
  },
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.fam-picker-instruction
  width: 100%
  top: -74px
  .copy
    font-size: 12px
    color: #999999
</style>
